import { IconDefinition } from "./types";

const chevronDown: IconDefinition = {
  iconName: "chevron-down",
  width: 16,
  height: 16,
  svgPathData: "M2 6l5.978 5L14 6",
  iconType: "stroke",
};

export { chevronDown };
